import React, { ReactNode } from 'react';

import Icon, { IconName } from './Icon';

// Generic 2-3 option segmented toggle.  Used for cards/rows view selection
// across Clients / Tombstones / Employees list pages.

interface Option<T extends string> {
  value: T;
  icon?: IconName;
  label?: string;
  ariaLabel?: string;
}

interface Props<T extends string> {
  options: ReadonlyArray<Option<T>>;
  value: T;
  onChange: (next: T) => void;
}

function SegmentedControl<T extends string>({ options, value, onChange }: Props<T>) {
  return (
    <div className="seg" role="tablist">
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            aria-label={opt.ariaLabel || opt.label || opt.value}
            className={active ? 'active' : ''}
            onClick={() => onChange(opt.value)}
          >
            {opt.icon && <Icon name={opt.icon} size={13} />}
            {opt.label as ReactNode}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
